module.exports = __webpack_public_path__ + "img/overview11.2a33642f.png";